import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n/config"; // MUST BE FIRST - Initialize i18n before App
// MUST stay ABOVE index.css: this is the one hop that gets Sass-compiled.
// A .scss imported from a .css file is inlined by css-loader and parsed by postcss as
// PLAIN CSS (Sass never runs) — that silently corrupted every selector that followed a
// `//` comment and made `@use` unresolvable. Importing it from JS routes it through
// sass-loader, which is also what emits the global :root design tokens. (DESIGN.md §6.1)
import "./styles/_global-rtl.scss";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById("root"));

let persistor = persistStore(store);

// Add error logging
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Defensive cleanup for the STATIC pre-React splash in public/index.html.
// React 18's createRoot() clears #root on its first render, so the splash is
// normally gone by the time this runs. If a future React version stops doing
// that, the splash (position:fixed, z-index:9999) would cover the whole app
// forever - so remove it on the next frame, AFTER React has had a chance to
// paint (double rAF), which cannot introduce a white gap.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const splash = document.getElementById('preload-splash');
    if (splash && splash.parentNode) {
      splash.parentNode.removeChild(splash);
    }
  });
});

// ROOT-CAUSE FIX (2026-09-02): React Fast Refresh performs a PARTIAL remount on
// hot updates. In this app the seller/account boot sequence (workspace splash →
// promise chain) hangs when remounted into a stale closure ("Preparing your
// workspace..." forever, spinners stuck), even though no reload loop occurs.
// A full page reload is the clean recovery (verified: full reloads settle
// correctly). Force any hot update of App to trigger a genuine reload instead
// of a partial Fast-Refresh remount. Dev-only — production builds have no
// module.hot.
if (module.hot) {
  module.hot.accept('./App', function () {
    window.location.reload();
  });
}

reportWebVitals();
